var map = {
	"./AheadRace-logo.jpg": 5355,
	"./Amista (1) (1).jpg": 8995,
	"./Amista .jpg": 3767,
	"./BostonLogix-Logo.jpg": 5140,
	"./Cigniti-Technologies.jpg": 9645,
	"./Cloud-Connects-Logo3.jpg": 1369,
	"./GSPANN-Logo.jpg": 8191,
	"./Hirexa-logo.jpg": 2165,
	"./M3BI-Logo.jpg": 4270,
	"./Mphasis.jpg": 5586,
	"./Paccore-Logo.jpg": 709,
	"./Softtek-logo.jpg": 1487,
	"./Tectoro-logo.jpg": 6922,
	"./ccpl_logo.jpg": 5727,
	"./logo-sriventech.jpg": 8347,
	"./merit.jpg": 2960,
	"./samodified.jpg": 7529,
	"./unionSys.jpg": 4699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4641;